import { useNavigate } from 'react-router-dom';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../../hooks/use-modal-params';
import { useDishMenuStore } from '../../../../../../../store/use-dish-menu-store';

export const useMenuInformerTableHeader = () => {
  const navigate = useNavigate();
  const { t } = useLang();

  const { putMenu, handleUpdateMenu, menu } = useDishMenuStore();

  const handlePutMenuStatus = async () => {
    handleUpdateMenu({ ...menu, is_on: !menu?.is_on });
    await putMenu();
  };

  const dishCategoryModal = useModalParams('dishCategory');
  const dishSectionModal = useModalParams('dishSection');
  const createDishModal = useModalParams('createDish');
  const menuSettingsModal = useModalParams('menuSettings');

  return {
    dishCategoryModal,
    dishSectionModal,
    menuSettingsModal,
    createDishModal,
    t,
    handlePutMenuStatus,
    menu,
    navigate,
  };
};
